export default {
  index: { method: 'get', url: 'algorithm/ambience-balance/rules' },
  show: { method: 'get', url: 'algorithm/ambience-balance/rules/{id}' },
  store: { method: 'post', url: 'algorithm/ambience-balance/rules' },
  update: { method: 'put', url: 'algorithm/ambience-balance/rules/{id}' },
  duplicate: { method: 'post', url: 'algorithm/ambience-balance/rules/{id}/duplicate' },
  toggle: { method: 'post', url: 'algorithm/ambience-balance/rules/{id}/toggle' },
  destroy: { method: 'delete', url: 'algorithm/ambience-balance/rules/{id}' },
}
